<template>
    <div class="busca-persona-container">


        <form class="row g-3 mb-4" @submit.prevent="buscarPersona">
            <div class="col-12 col-md-9">
                <input type="text" v-model="displayName" class="form-control text-uppercase" autocomplete="off"
                    placeholder="Ingrese apellidos y nombres" @keypress="soloLetras" required
                    aria-label="Nombre completo" />
                <small v-if="errorInput" class="text-danger">{{ errorInput }}</small>
            </div>
            <div class="col-12 col-md-3">
                <button type="submit" class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                    :disabled="loading || errorInput">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                    <span>{{ loading ? 'Consultando' : 'Buscar' }}</span>
                </button>
            </div>
        </form>

        <div class="results-container">
            <div class="table-responsive">
                <table class="table table-hover custom-table">
                    <thead class="table-light">
                        <tr>
                            <th class="text-center" style="width: 60px">#</th>
                            <th>Dni</th>
                            <th>Nombres Completos</th>
                            <th class="text-center">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="resultados.length === 0">
                            <td colspan="3" class="text-center py-3">
                                <i class="bi bi-search me-2"></i>
                                Sin resultados
                            </td>
                        </tr>
                        <tr style="font-size: 11px;" v-for="(item, index) in resultados" :key="index" class="result-row"
                            @click="seleccionarPersona(item)">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ item.identificacion }}</td>
                            <td>{{ item.nombresCompletos }}</td>
                            <td class="text-center">
                                <i @click="seleccionarPersona(item)" class="fa fa-check-circle"></i>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div v-if="error" class="alert alert-danger mt-3" role="alert">
            <i class="bi bi-exclamation-triangle me-2"></i>
            {{ error }}
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: "buscaPersona",
    data() {
        return {
            loading: false,
            isMobile: this.$isMobile,
            displayName: '',
            resultados: [],
            error: null,
            errorInput: null
        };
    },
    watch: {
        displayName: {
            handler(newValue) {
                // Primero reemplazamos la ñ por un carácter temporal para evitar su normalización
                let tempValue = newValue.replace(/ñ/g, '~').replace(/Ñ/g, '`');
                
                // Eliminamos tildes y caracteres especiales
                tempValue = tempValue
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .replace(/[^a-zA-Z\s~`]/g, '');
                
                // Restauramos la ñ
                this.displayName = tempValue
                    .replace(/~/g, 'ñ')
                    .replace(/`/g, 'Ñ');

                // Validar longitud mínima
                if (this.displayName.length < 3) {
                    this.errorInput = 'Debe ingresar al menos 3 caracteres';
                } else {
                    this.errorInput = null;
                }
            },
            immediate: true
        }
    },
    mounted() {
        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }
    },
    methods: {
        soloLetras(event) {
            // Permitir solo letras sin tildes, espacios, ñ y tecla Enter
            const tecla = event.key;
            const esLetra = /^[a-zA-ZñÑ\s]$/.test(tecla);
            const esTeclaControl = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(tecla);

            if (!esLetra && !esTeclaControl) {
                event.preventDefault();
            }
        },

        seleccionarPersona(persona) {

            let cedula = persona.identificacion;

            if (cedula.length === 13) {
                cedula = cedula.substring(0, cedula.length - 3);
            }

            // Crear una copia del objeto persona para no modificar el original
            const personaProcesada = {
                ...persona,
                identificacion: cedula
            };
            this.$emit('persona-seleccionada', personaProcesada);
        },

        buscarPersona() {
            if (this.errorInput) return;

            this.loading = true;
            this.error = null;
            this.resultados = [];

            this.$https2.post('/developers/getBuscaDisplayName', { displayName: this.displayName.toUpperCase() }, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                if (response.data.code === 200) {
                    this.resultados = response.data.data;
                } else {
                    this.resultados = [];
                }
            }).catch(error => {
                console.error('Error en la consulta:', error);
                this.error = 'Error al realizar la consulta. Por favor, intente nuevamente.';
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>

<style scoped>
.btn {
    min-width: 100px;
}

.spinner-border {
    width: 1rem;
    height: 1rem;
    border-width: 0.15em;
}

.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;
}

.table-responsive {
    margin-top: 1rem;
}

.custom-table {
    font-size: 0.9rem;
}

.custom-table thead th {
    font-size: 0.85rem;
    font-weight: 600;
    padding: 0.75rem;
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.custom-table tbody td {
    padding: 0.75rem;
    vertical-align: middle;
}

.result-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.result-row:hover {
    background-color: #f8f9fa;
}

@media (max-width: 768px) {
    .custom-table {
        font-size: 0.85rem;
    }

    .custom-table thead th,
    .custom-table tbody td {
        padding: 0.5rem;
    }

    .btn {
        min-width: 100%;
    }
}

.text-danger {
    font-size: 0.8rem;
    margin-top: 0.25rem;
}

input.form-control {
    text-transform: uppercase;
}

input.form-control::placeholder {
    text-transform: none;
}
</style>
